const personaTypeMap = {
    Unknown: 0,
    Person: 1,
    DistributionList: 2,
    // Room: 3,
    // Place: 4,
    ModernGroup: 5,
    //Birthday: 6,
    //CalendarPublicFolder: 7,
    //Booking: 8,
    //AtAllBroadcast: 9,
    ImplicitGroup: 10,
    ExplicitGroup: 11,
    LinkedIn: 12,
};

export default personaTypeMap;
